
import Vue from 'vue';
import ISDWebPlatform, { WPSettings } from './../../codebase/external.script';
import GUMService from './../../codebase/gum-service';
import Session from './../../codebase/Session';

import { DATE_SALE_START, DATE_SALE_END, DATE_SALE_BEGIN } from './../../main';

export default Vue.extend({
	name: 'DataTable',

	data: () => ({
		Data: [] as Array<Session>,
		Loading: false,
		Today: new Date(),
		Service: new GUMService(),
		Mindate: DATE_SALE_START as Date,
		Maxdate: DATE_SALE_END as Date,
		dateBegin: DATE_SALE_BEGIN as Date,
		DatePickerModel: '',
		saleMaxDepth: 7,
		saleMinDepth: 3,
		DisabledDates: [] as Array<string>,
	}),
	watch: {
		async DatePickerModel(): Promise<void> {
			if (!this.DatePickerModel) return;
			this.Loading = true;

			let date = this.dateFormatted;
			this.Data = await this.Service.GetSessions(date);
			this.Loading = false;
		},
	},
	computed: {
		theme: function () {
			return this.$vuetify.theme.currentTheme;
		},
		snackbar: function (): boolean {
			return this.occupiedDates.includes(this.DatePickerModel);
		},
		occupiedDates: function (): Array<string> {
			let yearCurrent = DATE_SALE_START.getFullYear();
			let yearNext = DATE_SALE_END.getFullYear();
			return [
				`${yearCurrent}-12-02`,
				`${yearCurrent}-12-03`,
				`${yearCurrent}-12-09`,
				`${yearCurrent}-12-10`,
				`${yearCurrent}-12-16`,
				`${yearCurrent}-12-17`,
				`${yearCurrent}-12-23`,
				`${yearCurrent}-12-24`,
				`${yearNext}-01-13`,
				`${yearNext}-01-14`,
				`${yearNext}-01-20`,
				`${yearNext}-01-21`,
				`${yearNext}-01-27`,
				`${yearNext}-01-28`,
				`${yearNext}-02-03`,
				`${yearNext}-02-04`,
				`${yearNext}-02-10`,
				`${yearNext}-02-11`,
				`${yearNext}-02-17`,
				`${yearNext}-02-18`,
				`${yearNext}-02-24`,
				`${yearNext}-02-25`,
			];
		},
		allowedDates: {
			get(): Array<Date> {
				if (this.Today.getTime() < this.dateBegin.getTime()) return [];
				return this.saleDates.filter((d: Date) => {
					// If the date is disabled
					let str = d.toLocaleDateString();
					if (this.DisabledDates.includes(str)) return false;

					// If date is outside maxDate limit
					let ts = d.getTime();
					if (ts > new Date(this.Maxdate).getTime()) return false;

					// If the date is found in season
					let find = this.season.find((date) => {
						return d.toLocaleDateString() == date.toLocaleDateString();
					});
					return find;
				});
			},
		},
		season: {
			get(): Array<Date> {
				let dif = this.datesBetween(this.Mindate, this.Maxdate);
				return dif;
			},
		},
		saleDates: {
			get(): Array<Date> {
				return this.datesBetween(this.Today, this.dateOnDepth);
			},
		},
		saleDepth: {
			get: function () {
				let yearCurrent = DATE_SALE_START.getFullYear();
				let yearNext = DATE_SALE_END.getFullYear();
				// Debug purposes
				if (this.Today < new Date(`${yearCurrent}/11/25`)) return 15;
				// Уменьшение глубины продаж с 23 декабря по 9 января
				let reduceDateA = new Date(`${yearCurrent}/12/22`);
				let reduceDateB = new Date(`${yearNext}/01/08`);
				if (this.Today.getTime() > reduceDateA.getTime() && this.Today.getTime() < reduceDateB.getTime()) return this.saleMinDepth;
				return this.saleMaxDepth;
			},
		},
		dateOnDepth: function (): Date {
			return new Date(new Date(this.Today).setDate(new Date(this.Today).getDate() + this.saleDepth));
		},
		minDate: {
			get(): string {
				let d: Date = new Date(this.Today);
				if (d.getTime() > this.Mindate.getTime()) {
					return this.localizeDate(d);
				} else {
					return this.localizeDate(this.Mindate);
				}
			},
		},
		maxDate: {
			get: function (): string {
				return this.localizeDate(this.lastDate);
			},
		},
		lastDate: function (): Date {
			return this.allowedDates[this.allowedDates.length - 1];
		},
		dateFormatted: {
			get: function () {
				return this.DatePickerModel.replace('/', '-').split('-').reverse().join('.');
			},
		},
	},
	created(): void {
		this.DatePickerModel = this.minDate;
		let script = document.createElement('script');
		script.src = 'https://sale.moipass.ru/external.script.js?random=' + Math.floor(Math.random() * 10000);
		script.type = 'text/javascript';
		let minDate = this.minDate;
		let maxDate = this.lastDate.toLocaleDateString('ru-RU');
		let disableddates = this.DisabledDates;

		script.addEventListener('load', function () {
			let settings = {
				id: 16,
				type: 'modal',
				tariffsseancesfilter: true,
				saletermstype: 'checkbox',
				servicecalendar: 'page',
				shownoticketsseances: 'true',
				mindate: minDate,
				maxdate: maxDate,
				disableddates: disableddates,
				onlytab: ['service'],
				nopromo: false,
				cartmaxitems: 8,
				disablemultipleseances: true,
				resetcart: true,
			} as WPSettings;
			(window as unknown as ISDWebPlatform).WPInit(settings);
		});
		document.head.append(script);
	},
	methods: {
		localizeDate: function (date: Date): any {
			return date.toLocaleDateString('ru-RU').replaceAll('/', '.').split('.').reverse().join('-');
		},
		datesBetween(date1: Date, date2: Date): any {
			let sorted = [new Date(date1), new Date(date2)]
				.map((d) => d.getTime())
				.sort()
				.map((d) => new Date(d));
			let dib: any[] = [];
			const LAST = sorted[sorted.length - 1];
			for (let d = new Date(sorted[0]); d < LAST; d.setDate(d.getDate() + 1)) {
				dib.push(new Date(d));
			}
			return dib;
		},
		OpenWP(): void {
			if (this.DatePickerModel) {
				(window as unknown as ISDWebPlatform).WPOpenModal({
					id: 16,
					forcedate: this.dateFormatted,
					shownoticketsseances: 'true',
				});
			}
		},
		OpenTELE2() {
			if (this.DatePickerModel) {
				(window as unknown as ISDWebPlatform).WPOpenModal({
					id: 743,
					forcedate: this.dateFormatted,
					cartminitems: 2,
					shownoticketsseances: 'true',
				});
			}
		},
		allowed(date: string): boolean {
			// date format: 2023-01-31
			let stringDate = new Date(date).toLocaleDateString('ru-RU');
			if (this.DisabledDates.includes(stringDate)) return false;
			let dd = new Date(date).toLocaleDateString();
			if (this.allowedDates.find((d) => d.toLocaleDateString() === dd)) return true;
			return false;
		},
	},
});
